import React, { Component } from "react";
import { Typography, Grid } from "@material-ui/core";

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <Grid xs={12} style={{ position: "absolute", bottom: 0, right: "4%", left: "4%" }}>
                <Typography color="textPrimary" style={{ fontWeight: 600, marginTop: -10 }}>
                    Report C`AGCU
                </Typography>
                <Typography variant="body2" color="textSecondary" style={{ marginTop: -10 }}>
                    Dinas Pendidikan Jawa Timur
                </Typography>

                <Typography variant="body2" color="textPrimary" style={{ float: "right", marginTop: "-18px" }}>
                    {this.props.halaman}
                </Typography>
                <hr className="line-red" />

                {/* <img src="/image/dinas/logo-eduprime.png" style={{float: 'right', marginTop: '-10px', width: 70}} /> */}
                <Typography variant="subtitle2" color="textSecondary" style={{ float: "right", marginTop: "-16px" }}>
                    Supported By:{" "}
                </Typography>
            </Grid>
        );
    }
}

export default Footer;
